import React, { FunctionComponent, MouseEvent, ReactNode } from "react";
import useRouterContext from "../hooks/useRouterContext";

interface Props {
  children?: ReactNode;
  href: string;
}

const Link: FunctionComponent<Props> = ({ children, href, ...other }) => {
  const context = useRouterContext();

  const onClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (!event.ctrlKey && !event.metaKey) {
      event.preventDefault();
      context.history.push(href);
    }
  };

  return (
    <a href={href} onClick={onClick} {...other}>
      {children}
    </a>
  );
};

export default Link;
